import { render, staticRenderFns } from "./TrainingOnlineDetail.vue?vue&type=template&id=55dba1a9&scoped=true"
import script from "./TrainingOnlineDetail.vue?vue&type=script&lang=js"
export * from "./TrainingOnlineDetail.vue?vue&type=script&lang=js"
import style0 from "./TrainingOnlineDetail.vue?vue&type=style&index=0&id=55dba1a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dba1a9",
  null
  
)

export default component.exports